/*
 * Module for the standard response page
 */

define([
  "marionette",
  "messaging/messenger",
  "./standardResponseView",
  "modules/topicsSplit/topic/topicResponse/topicResponseModule",
  "./standardResponseHeader/standardResponseHeaderModule",
], function (
  Marionette,
  Messenger,
  StandardResponseView,
  TopicResponseModule,
  StandardResponseHeaderModule,
) {
  return Marionette.Controller.extend({
    initialize: function ({ region }) {
      this.name = "standardResponse";
      this.region = region;
      this._setUpReqRes();
    },
    save: function () {
      this.standardResponse.saveModel();
    },
    show: function (standardResponse) {
      this.standardResponse = standardResponse;
      this.layout = new StandardResponseView.standardResponseLayout({ model: standardResponse });
      this.header = this.addSubModule(
        new StandardResponseHeaderModule({
          region: this.layout.header,
        }),
      );
      this.response = this.addSubModule(
        new TopicResponseModule({
          region: this.layout.response,
          allowDisable: false,
          showCategoryTab: false,
          showAttributesTab: false,
          skipExpandWithContext: true,
          skipShareResponseLinks: true,
        }),
      );
      this.layout.on("show", () => this._showSubViews(standardResponse));
      const downloadCookie = Messenger.reqres.request("get:download:cookie");
      this.showRegion(this.layout, { loading: true, entities: [downloadCookie, standardResponse] });
    },
    _showSubViews: function (standardResponse) {
      this.header.show(standardResponse);
      this.response.show(standardResponse, standardResponse.liveResponse);
    },
    _setUpReqRes: function () {
      Messenger.reqres.setHandler("current:topic", () => this.standardResponse, this);
      Messenger.reqres.setHandler("current:topic:id", () => this.standardResponse.id, this);
      Messenger.reqres.setHandler(
        "current:topic:status",
        () => this.standardResponse.get("statusId"),
        this,
      );
    },
  });
});
